import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import "./register.css";
import Logo from "../../Images/Livon logos 1-03.png";
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { toast } from "react-toastify";
import baseUrl from "../../Environment";
import axios from "axios";
import { Visibility } from "@mui/icons-material";
import { VisibilityOff } from "@mui/icons-material";
const Login = () => {
  const [state, setState] = useState("Sign Up");
  const [otp, setOtp] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
    otp: "",
    action: "",
  });
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isRunning) {
      return;
    }
    const numericValue = formData.phoneNumber;
    if (numericValue.length !== 13) {
      toast.error(
        "Phone number is required and should be 13 characters including country code.",
        {
          style: {
            color: "white",
          },
        }
      );
      return;
    }
    const updatedFormData = {
      ...formData,
      action: state === "Sign Up" ? "REGISTRATION" : "LOGIN",
    };
    try {
      const url = baseUrl + "user/create";
      const response = await axios.post(url, updatedFormData, {
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      if (data.success) {
        toast.success(
          `OTP sent successfully. Please Enter OTP for ${state === "Sign Up" ? "registration" : "login"}`,
          {
            style: {
              color: "white",
            },
          }
        );
        setOtp(true);
        startTimer();
      } else {
        toast.error("OTP sending failed: " + data.message, {
          style: {
            color: "white",
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);

      // Check if error has a response from the server
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // Display the backend error message
        toast.error(error.response.data.message, {
          style: {
            color: "white",
          },
        });
      } else {
        // Fallback for other types of errors
        toast.error("An unexpected error occurred. Please try again.", {
          style: {
            color: "white",
          },
        });
      }
    }
  };
  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    if (!formData.otp) {
      return toast.warning("Please enter OTP to continue");
    }

    const actionType = state === "Sign Up" ? "REGISTRATION" : "LOGIN";
    const updatedFormData = { ...formData, action: actionType };

    try {
      const response = await axios.post(
        baseUrl + "user/create",
        updatedFormData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = response.data;

      if (data.success) {
        setIsRunning(false);
        setTimeLeft(0);
        setOtp(false);

        toast.success(
          state === "Sign Up"
            ? "Registered successfully. Please log in"
            : "Logged in successfully.",
          { style: { color: "white" } }
        );

        if (state === "Sign Up") {
          setState("Login");
        } else {
          localStorage.setItem("phoneNumber", updatedFormData.phoneNumber);
          window.location.href = "/";
        }

        // Reset form data
        setFormData({
          name: "",
          email: "",
          password: "",
          phoneNumber: "",
          otp: "",
        });
      } else {
        toast.error(data.message || "Something went wrong", {
          style: { color: "white" },
        });
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);

      toast.error(
        error.response?.data?.message ||
          "Something went wrong. Please try again.",
        { style: { color: "white" } }
      );
    }
  };

  useEffect(() => {
    let timer;
    if (isRunning && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      clearInterval(timer);
      setIsRunning(false);
      setOtp(false);
    }
    return () => clearInterval(timer);
  }, [isRunning, timeLeft]);
  const startTimer = () => {
    setTimeLeft(10 * 60);
    setIsRunning(true);
  };
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      onSubmit={handleSubmit}
      sx={{ width: "100%", height: "100vh" }}
    >
      <Box
        component="form"
        sx={{ width: "400px", p: 3, boxShadow: 3, borderRadius: 2 }}
      >
        <div className="flex justify-center my-3">
          <img style={{ width: "150px" }} alt="logo" src={Logo} />
        </div>
        <Typography
          variant="h5"
          sx={{
            color: "primary.main",
            fontWeight: "bold",
            textAlign: "center",
            mb: 3,
          }}
        >
          {state === "Sign Up" ? "Create Account" : "Login"}
        </Typography>

        {state === "Sign Up" && (
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
          />
        )}

        {state === "Sign Up" && (
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
          />
        )}

        {state === "Sign Up" && (
          <TextField
            fullWidth
            label="Password"
            name="password"
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseUpPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={formData.password}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
          />
        )}

        <Box sx={{ mt: 2 }}>
          <PhoneInput
            country={"in"}
            required
            inputStyle={{
              width: "100%",
              height: "56px",
              borderRadius: "4px",
              border: "1px solid #c4c4c4",
              padding: "0 14px",
              fontSize: "16px",
              boxSizing: "border-box",
            }}
            buttonStyle={{
              borderRadius: "4px 0 0 4px",
              borderRight: "1px solid #c4c4c4",
              height: "56px",
            }}
            containerStyle={{
              width: "100%",
              display: "flex",
            }}
            placeholder="Phone Number"
            value={formData.phoneNumber}
            onChange={(value) => {
              const formattedValue = value.replace(/\s/g, "");
              if (state === "Sign Up") {
                setFormData({ ...formData, phoneNumber: `+${formattedValue}` });
              } else {
                setFormData({ ...formData, phoneNumber: `+${formattedValue}` });
              }
            }}
            enableSearch
          />
          <div
            className={`d-${isRunning ? "block" : "none"} flex justify-center items-center`}
          >
            <p>
              Resend OTP in <span className="bi bi-clock"></span>{" "}
              {formatTime(timeLeft)}
            </p>
          </div>
        </Box>

        <div className="flex W-100 row justify-between my-2 mt-3 items-center">
          <div className={`col-${otp ? "6" : "12"} mt-2`}>
            {state === "Sign Up" ? (
              <Button
                variant="contained"
                type="submit"
                fullWidth
                disabled={isRunning}
                onSubmit={handleSubmit}
                className="btn btn-primary "
                style={{ padding: "8px" }}
              >
                {isRunning ? "RESend otp" : "SEND OTP"}
              </Button>
            ) : (
              <Button
                variant="contained"
                type="submit"
                fullWidth
                disabled={isRunning}
                onSubmit={handleSubmit}
                className="btn btn-primary"
                style={{ padding: "8px" }}
              >
                {isRunning ? "RESend otp" : "SEND OTP"}
              </Button>
            )}{" "}
          </div>

          <div className="col-6">
            <TextField
              className={`d-${otp ? "block" : "none"}`}
              label="OTP"
              name="otp"
              type="text"
              size="small"
              required={otp}
              value={formData.otp}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
            />
          </div>
        </div>

        {state === "Sign Up" ? (
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={`d-${otp ? "block" : "none"}`}
            fullWidth
            onClick={handleOtpSubmit}
            sx={{ mt: 2 }}
          >
            Create Account{" "}
          </Button>
        ) : (
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={`d-${otp ? "block" : "none"}`}
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleOtpSubmit}
          >
            Login{" "}
          </Button>
        )}

        <Typography textAlign="center" sx={{ mt: 2 }}>
          {state === "Sign Up" ? (
            <>
              Already have an account? &nbsp;
              <Button
                onClick={() => {
                  setState("Login");
                  setOtp(false);
                  setIsRunning(false);
                  setFormData({
                    name: "",
                    email: "",
                    password: "",
                    otp: "",
                    phoneNumber: "+91",
                  });
                }}
                sx={{ textTransform: "none", p: 0 }}
                style={{ fontWeight: "bold", fontSize: "18px" }}
              >
                Login Here
              </Button>
            </>
          ) : (
            <>
              Don’t have an account? &nbsp;
              <Button
                onClick={() => {
                  setState("Sign Up");
                  setOtp(false);
                  setIsRunning(false);
                  setFormData({
                    name: "",
                    email: "",
                    password: "",
                    otp: "",
                    phoneNumber: "+91",
                  });
                }}
                sx={{ textTransform: "none", p: 0 }}
                style={{ fontWeight: "bold", fontSize: "18px" }}
              >
                Create Here
              </Button>
            </>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
